import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import Header from "./Header";
import Hero from "./Hero";
import Services from "./Services";
import Process from "./Process";
import Advantages from "./Advantages";
import Partners from "./Partners";
import Contact from "./Contact";
import Footer from "./Footer";
import SeoHelmet from "./SeoHelmet";
import { organizationSchema, websiteSchema } from "../utils/schemaOrg";

const Home = () => {
  const { currentLanguage } = useLanguage();
  return (
    <div className="min-h-screen bg-white">
      <SeoHelmet
        title={currentLanguage === "EN"
          ? "VELOX HINT — Non-tariff Regulation & Certification"
          : "ВЕЛОКС ХИНТ — Нетарифное регулирование и сертификация"}
        description={currentLanguage === "EN"
          ? "Professional consulting on customs clearance, certification and licensing in Russia and the EAEU. 15+ years of experience."
          : "Профессиональные услуги по таможенному оформлению, сертификации и лицензированию в России и ЕАЭС. 15+ лет опыта."}
        path="/"
        jsonLd={[organizationSchema({ language: currentLanguage }), websiteSchema()]}
      />
      <Header />
      <Hero />
      <Services />
      <Process />
      <Advantages />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
